<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2021 (original work) Open Assessment Technologies SA
    import { Icon } from '@oat-sa-private/ui-elements';

    // {string} - error title
    export let title;
    // {string} - error message
    export let info;
    // {string} - name of the icon to display taken from this list https://github.com/oat-sa/live-design-system/blob/master/packages/identity/icons/dist/icons.json
    export let icon = 'lightning-16';
</script>

<style>
    #wrapper {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        text-align: center;
        min-height: 100vh;
    }

    section {
        display: flex;
        flex-direction: column;
        text-align: left;
    }

    h5 {
        font-size: 5rem;
        padding: 0;
        margin: 0;
    }

    p {
        margin-top: 1rem;
        max-width: 50rem;
    }

    .icon-container {
        width: 10rem;
        height: 10rem;
        margin: 0 8rem 0 0;

        & :global(.icon) {
            transform: translateX(4rem) translateY(3.5rem) scale(5);
        }
    }
</style>

<div id="wrapper">
    <div class="icon-container">
        <Icon name={icon} />
    </div>
    <section>
        <h5>{title}</h5>
        <p>{info}</p>
    </section>
</div>
